"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsRoute
 * @description Baasic Notifications Registrations Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var _1 = require("./");
var NotificationsRegistrationsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsRoute, _super);
    function NotificationsRegistrationsRoute(appOptions, notificationsRegistrationsUsersRoute, notificationsRegistrationsAnonymousRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsUsersRoute = notificationsRegistrationsUsersRoute;
        _this.notificationsRegistrationsAnonymousRoute = notificationsRegistrationsAnonymousRoute;
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsRoute.prototype, "users", {
        get: function () {
            return this.notificationsRegistrationsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsRoute.prototype, "anonymous", {
        get: function () {
            return this.notificationsRegistrationsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsRegistrationsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersRoute !== "undefined" && _1.NotificationsRegistrationsUsersRoute) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsAnonymousRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousRoute) === "function" ? _c : Object])
    ], NotificationsRegistrationsRoute);
    return NotificationsRegistrationsRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsRoute = NotificationsRegistrationsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
